export class Geolocation {
  constructor() {}

  position(callback, error, options) {
    return navigator.geolocation.getCurrentPosition(callback, error, options);
  }
}
